import React from 'react';
import { PL_ESTABLISHMENT_FEE } from '../../utils/constants';

export const repaymentsPerMonthOptions = [
  { text: 'Weekly', value: 4 },
  { text: 'Fortnightly', value: 2 },
  { text: 'Monthly', value: 1 }
];

export const loans = [
  {
    name: 'Latitude Personal Loan',
    rate: 17.4,
    comparisonRate: 18.58,
    loanMonthlyFee: 13,
    comparisonRateText: ' (comparison rate 18.58%)*',
    getEstablishmentFee: (loanAmount) => {
      return PL_ESTABLISHMENT_FEE;
    },
    disclaimer: (
      <div>
        <p>
          <strong>Latitude Personal Loan</strong>
        </p>
        <p>
          The results shown using this calculator is an estimate only, based on
          the information you have provided.
        </p>
        <p>
          ^ Results are based on an average fixed interest rate of{' '}
          <strong>17.4% p.a.</strong> (18.58%* p.a. comparison rate).
        </p>
        <p>
          Your interest rate may be different and will be based on a number of
          factors, including the information you provide and our assessment of
          your application. We will confirm your approved interest rate in your
          loan contract.
        </p>
        <p>
          For the &apos;Latitude Personal Loan&apos; interest rates range from
          5.99% to 21.99% p.a. (comparison rate 7.26% to 23.15% p.a.) for
          secured loans, and from 7.99% to 22.99% p.a. (comparison rate 9.24% to
          24.15% p.a.), for unsecured loans.
        </p>
        <p>
          The results from this calculator should be used as an indication only,
          and they do not represent either a quote or pre-qualification or
          approval for a loan. It is provided for illustrative purposes only and
          actual borrowing capacity and interest rates may vary.
        </p>
        <p>
          * Comparison rate for the above product is based on a loan of $30,000
          over 5 years.
        </p>
        <p>
          <strong>WARNING:</strong> The comparison rate is true only for the
          example given and may not include all fees and charges. Different
          terms, fees or other loan amounts might result in a different
          comparison rate.
        </p>
        <p>
          EXAMPLE: A secured personal loan of $30,000 borrowed for 5 years with
          the minimum interest rate of 10.99% p.a. (12.21% p.a. comparison
          rate), would equate to a total amount payable of $40,233 (including a
          ${PL_ESTABLISHMENT_FEE} establishment fee and $13 monthly loan servicing
          fees).
        </p>
        <p>
          ~ Includes the ${PL_ESTABLISHMENT_FEE} establishment fee and the $16.50
          monthly loan service fee.
        </p>
      </div>
    )
  },
  {
    name: 'Latitude Car and Motor Loan',
    rate: 11.15,
    loanMonthlyFee: 10,
    comparisonRate: 12.24,
    comparisonRateText: ' (comparison rate 12.24%)*',
    getEstablishmentFee: () => {
      return 295;
    },
    disclaimer: (
      <div>
        <p>
          <strong>Latitude Car and Motor Loan</strong>
        </p>
        <p>
          The results shown using this calculator are an estimate only, based on
          the information you have provided.
        </p>
        <p>
          ^ Results are based on an average fixed interest rate of{' '}
          <strong>11.15% p.a.</strong> (12.24%* p.a. comparison rate).
        </p>
        <p>
          Your interest rate may be different and will be based on a number of
          factors, including the information you provide and our assessment of
          your application. We will confirm your approved interest rate in your
          loan contract.
        </p>
        <p>
          For the &apos;Latitude Car Loan&apos; interest rates range from 6.99%
          to 14.99% p.a. (comparison rate 8.10% to 16.06% p.a.).
        </p>
        <p>
          The results from this calculator should be used as an indication only,
          and they do not represent either a quote or pre-qualification or
          approval for a loan. It is provided for illustrative purposes only and
          actual borrowing capacity and interest rates may vary.
        </p>
        <p>
          * Comparison rate for the above product is based on a loan of $30,000
          over 5 years.
        </p>
        <p>
          <strong>WARNING:</strong> The comparison rate is true only for the
          example given and may not include all fees and charges. Different
          terms, fees or other loan amounts might result in a different
          comparison rate.
        </p>
        <p>
          EXAMPLE: A secured personal loan of $30,000 borrowed for 5 years with
          the minimum interest rate of 6.99% p.a. (8.10% p.a. comparison rate),
          would equate to a total amount payable of $36,584 (including a $295
          establishment fee and $10 monthly loan servicing fees).
        </p>
        <p>
          ~ Includes the $295 establishment fee and the $10 monthly loan service
          fee.
        </p>
      </div>
    )
  },
  {
    name: 'Gem Car Loan',
    rate: 15.21,
    disclaimer: (
      <div>
        <p>
          <strong>GEM Finance – Car Loan</strong>
        </p>
        <p>
          The results shown using this calculator are an estimate only, based on
          the information you have provided..
        </p>
        <p>
          ^ Results are based on an average fixed interest rate of{' '}
          <strong>12.21% p.a.</strong>
        </p>
        <p>
          Your interest rate depends on the amount borrowed, your personal
          circumstances and credit history. The interest rate and repayment
          amount remain the same for the whole loan with no early repayment fee.
          You can make lump sum repayments at any time with no penalty.
        </p>
        <p>
          For the &apos;Gem Car Loan&apos; interest rates range from 12.99% to
          18.99% p.a.{' '}
        </p>
        <p>
          The results from this calculator should be used as an indication only,
          and they do not represent either a quote or pre-qualification or
          approval for a loan. It is provided for illustrative purposes only and
          actual borrowing capacity and interest rates may vary.
        </p>
        <p>
          EXAMPLE: A Gem Personal Loan of $15,000 borrowed for 3 years with a
          minimum interest rate of 12.99% p.a. would equate to a total amount
          payable of $18,516.60 (including a $240 establishment fee).
        </p>
        <p>
          Fees and charges are payable and the calculations do not take these
          into account.
        </p>
      </div>
    )
  },
  {
    name: 'Gem Personal Loan',
    rate: 18.36,
    disclaimer: (
      <div>
        <p>
          <strong>GEM Finance – Personal Loan</strong>
        </p>
        <p>
          The results shown using this calculator are an estimate only, based on
          the information you have provided..
        </p>
        <p>
          ^ Results are based on an average fixed interest rate of{' '}
          <strong>18.36% p.a.</strong>
        </p>
        <p>
          Your interest rate depends on the amount borrowed, your personal
          circumstances and credit history. The interest rate and repayment
          amount remain the same for the whole loan with no early repayment fee.
          You can make lump sum repayments at any time with no penalty.
        </p>
        <p>
          For the &apos;Gem Personal Loan&apos; interest rates range from 12.99%
          to 29.99% p.a.
        </p>
        <p>
          The results from this calculator should be used as an indication only,
          and they do not represent either a quote or pre-qualification or
          approval for a loan. It is provided for illustrative purposes only and
          actual borrowing capacity and interest rates may vary.
        </p>
        <p>
          EXAMPLE: A Gem Personal Loan of $15,000 borrowed for 3 years with a
          minimum interest rate of 12.99% p.a. would equate to a total amount
          payable of $18,516.60 (including a $240 establishment fee).
        </p>
        <p>
          Fees and charges are payable and the calculations do not take these
          into account.
        </p>
      </div>
    )
  }
];

export const loanPurposeOptionsLatitude = [
  {
    text: 'Car purchase',
    value: 'Car purchase',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/car-and-motor-loans.html'
  },
  {
    text: 'Other vehicle purchase',
    value: 'Other vehicle purchase',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/car-and-motor-loans.html'
  },
  {
    text: 'Car repairs',
    value: 'Car repairs',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/other-personal-loans.html'
  },
  {
    text: 'Debt consolidation',
    value: 'Debt consolidation',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/debt-consolidation-loans/'
  },
  {
    text: 'Educational expenses',
    value: 'Educational expenses',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/other-personal-loans.html'
  },
  {
    text: 'Home improvements',
    value: 'Home improvements',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/home-renovation-loans/'
  },
  {
    text: 'Household furnishings',
    value: 'Household furnishings',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/other-personal-loans.html'
  },
  {
    text: 'Medical / Dental',
    value: 'Medical / Dental',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/other-personal-loans.html'
  },
  {
    text: 'Small debts',
    value: 'Small debts',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/other-personal-loans.html'
  },
  {
    text: 'Travel',
    value: 'Travel',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/travel-loans/'
  },
  {
    text: 'Other',
    value: 'Other',
    findOutMoreAddress:
      'https://www.latitudefinancial.com.au/loans/other-personal-loans.html'
  }
];

export const loanPurposeOptionsGem = [
  {
    text: 'Auto Purchase',
    value: 'Auto Purchase',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/car-loans.html'
  },
  {
    text: 'Auto Repairs',
    value: 'Auto Repairs',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/personal-loans.html'
  },
  {
    text: 'Debt consolidation',
    value: 'Consolidation',
    findOutMoreAddress:
      'https://www.gemfinance.co.nz/loans/debt-consolidation-loans/'
  },
  {
    text: 'Educational expenses',
    value: 'Education',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/personal-loans.html'
  },
  {
    text: 'Home improvements',
    value: 'Home improvements',
    findOutMoreAddress:
      'https://www.gemfinance.co.nz/loans/home-renovation-loans.html'
  },
  {
    text: 'Household furnishings',
    value: 'Household furnishings',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/personal-loans.html'
  },
  {
    text: 'Medical & Dental',
    value: 'Medical %26 Dental',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/personal-loans.html'
  },
  {
    text: 'Other vehicle purchase',
    value: 'Caravan/Boat/Recreational',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/personal-loans.html'
  },
  {
    text: 'Small debts',
    value: 'Other',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/personal-loans.html'
  },
  {
    text: 'Travel',
    value: 'Travel/Holiday',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/travel-loans.html'
  },
  {
    text: 'Other',
    value: 'Other',
    findOutMoreAddress: 'https://www.gemfinance.co.nz/loans/personal-loans.html'
  }
];

export const payitOverYearsOptions = [
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 }
];

export const repaymentForOptions = [
  { text: 'Car', value: 'Car' },
  { text: 'Caravan', value: 'Caravan' },
  { text: 'Motorbike', value: 'Motorbike' },
  { text: 'Boat', value: 'Boat' },
  { text: 'Light Vehicle', value: 'Light Vehicle' }
];
